import React from 'react'
import { useState } from 'react';

class ReadMore extends React.Component{
    constructor(){
        super();
        this.state = {
            isReadMore: true
        }
    }    
    renderLink = () => {
        const {isReadMore} = this.state;
        return (
            <span>... <span className='text_link' onClick={() => this.setState(s => ({isReadMore: !s.isReadMore}))}>{isReadMore ? "Read more" : "Read less"}</span></span>
        )
    }
    render(){
        if(!this.props.content) return <></>

        const {isReadMore} = this.state;
        const limit = this.props.limit || 250;
        const content = isReadMore ? this.props.content.substring(0, limit) : this.props.content;
        return (
            <span>
                {content}
                {(this.props.content.length > limit ? this.renderLink() : null)}
            </span>
        )

    }

}

export default ReadMore